import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Alert, CircularProgress, Paper, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';

const ReceptionistBookingsPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoading(true);
        const res = await api.get('/receptionist/bookings', { params: { limit: 25 } });
        setBookings(res.data.data || []);
      } catch (err) {
        const status = err?.response?.status;
        const url = err?.config?.url;
        const msg = err?.response?.data?.error || err.message || 'Unknown error';
        setError(t('receptionist:bookings.errors.loadFailed', { status: status || 'n/a', url: url || '', message: msg }));
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('receptionist:bookings.title')}
      </Typography>
      <Paper sx={{ p: 2 }}>
        {loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={20} />
            <Typography>{t('receptionist:bookings.loading')}</Typography>
          </Box>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        )}
        {!loading && !error && (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {t('receptionist:bookings.showingCount', { count: bookings.length })}
            </Typography>
            {bookings.length === 0 && (
              <Alert severity="info">{t('receptionist:bookings.noBookings')}</Alert>
            )}
            {bookings.length > 0 && (
              <Box component="ul" sx={{ pl: 3, m: 0 }}>
                {bookings.map(b => (
                  <li key={b._id}>
                    <Typography variant="body2">
                      {b.facility?.name || 'Facility'} — {new Date(b.startTime).toLocaleString()} ({b.status})
                    </Typography>
                  </li>
                ))}
              </Box>
            )}
          </>
        )}
      </Paper>
    </Container>
  );
};

export default ReceptionistBookingsPage;

